'use client';
import { jsx } from 'react/jsx-runtime';
import styled from 'styled-components';
import { withTitan } from '../../hocs/withTitan/withTitan.js';
import { EmptyState } from '../EmptyState/EmptyState.js';
import { Flex } from '../Flex/Flex.js';

const ErrorContainer = styled.div.withConfig({
  componentId: "sc-19sx8wd-0"
})(["display:flex;flex-direction:column;justify-content:center;height:inherit;text-align:center;margin:auto;"]);
const DrawerError = /*#__PURE__*/withTitan(({
  title,
  description,
  buttonText,
  onReset,
  className,
  testId = 'drawerError'
}) => {
  return jsx(ErrorContainer, {
    className: className,
    "data-test-id": testId,
    children: jsx(Flex, {
      alignItems: "center",
      flexDirection: "column",
      justifyContent: "center",
      children: jsx(EmptyState, Object.assign({
        description: description,
        testId: testId,
        title: title
      }, onReset && buttonText && {
        link: {
          label: buttonText,
          onClick: onReset
        }
      }))
    })
  });
}, {
  name: 'DrawerError'
});

export { DrawerError };
//# sourceMappingURL=DrawerError.js.map
